import React from 'react';
import {useHistory} from 'react-router';
import {ContentMail} from 'components/Ui/Icon';
import {useCreateContentMailTemplateMutation} from 'api';

export default () => {
  const history = useHistory();

  const [createContentMailTemplate] = useCreateContentMailTemplateMutation({
    onCompleted: ({createContentMailTemplate: {content = {}}}) => {
      history.push(`/garage/contents/${content.uuid}/mail_template`);
    },
  });

  return (
    <div onClick={() => createContentMailTemplate()}>
      <ContentMail color="var(--primary)" className="active" />
      <ContentMail color="var(--text-color-2)" className="inactive" />
      <p>メールテンプレート</p>
    </div>
  );
};
